export const DEAL_TYPE_OPTIONS = [
  { label: 'Priced Round', value: 'Priced Round' },
  { label: 'SAFE', value: 'SAFE' },
  { label: 'Convertible Note', value: 'Convertible Note' },
  { label: 'KISS', value: 'KISS' },
  { label: 'Debt', value: 'Debt' },
];

export const INVESTMENT_STAGE_OPTIONS = [
  { label: 'Pre-Seed', value: 'Pre-Seed' },
  { label: 'Seed', value: 'Seed' },
  { label: 'Series A', value: 'Series A' },
  { label: 'Series B', value: 'Series B' },
  { label: 'Acquisition', value: 'Acquisition' },
];
